<div class="cbsw-timezone-select">
  @if (usePartnerTimezone) {
    <p class="cbsw-timezone-partner-hint">
      {{ 'booking_components.timezone_partner_hint' | translate: { timezone: partnerTimezoneLabel } }}
    </p>
  } @else {
    <ng-select
      #timezoneSelection="ngModel"
      [(ngModel)]="selectedTimezone"
      [clearable]="false"
      name="timezone_selection"
      [loading]="isTimezonesLoading"
      (change)="onTimezoneChange($event)"
    >
      @for (timezone of timezones; track $index) {
        <ng-option value="{{ timezone.zone }}">
          {{ timezone | translation: 'name': lang }}
        </ng-option>
      }
    </ng-select>
  }
</div>
